import { tap2mineContract } from 'shared';
import { Address } from 'viem';

export const getOwnedNftId = async (address: Address) => {
  const nftIds = Array.from({ length: 6 }, (_, i) => BigInt(i));
  const balances = await tap2mineContract.read.balanceOfBatch([nftIds.map(() => address), nftIds]);

  const ownedNftId = balances.findIndex((v) => v !== BigInt(0));

  return ownedNftId !== -1 ? ownedNftId : null;
};
